import { useEffect, useState } from "react";
import classNames from "classnames";
import { QuestionAndAnswerProps } from "@/utils/formatCategoryPage";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { PlusIcon } from "@/public/icons/PlusIcon";
import { MinusIcon } from "@/public/icons/MinusIcon";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./QuestionAndAnswer.module.scss";

export const QuestionAndAnswer = ({
  question,
  answer,
  isOpen = false,
  selectedTab,
}: QuestionAndAnswerProps) => {
  const [isOpened, setIsOpened] = useState(isOpen);

  useEffect(() => {
    setIsOpened(isOpen);
  }, [selectedTab, isOpen]);

  return (
    <div className={styles.qAndA}>
      <div
        className={styles.question}
        onClick={() => (isOpened ? setIsOpened(false) : setIsOpened(true))}
      >
        <div className={styles.questionLabel}>{question}</div>
        <div className={styles.questionButton}>
          {!isOpened && (
            <div className={styles.questionIcon}>
              <PlusIcon color={"#062e5e"}></PlusIcon>
            </div>
          )}
          {isOpened && (
            <div className={styles.questionIcon}>
              <MinusIcon color={"#062e5e"}></MinusIcon>
            </div>
          )}
        </div>
      </div>
      <div
        className={classNames(styles.answer, {
          [styles.isOpened]: isOpened,
        })}
        dangerouslySetInnerHTML={injectPurifiedHTML(removeEmptyRel(answer))}
      />
    </div>
  );
};
